import { Void } from "@pdfking/tfunc"

import { AlmostNullQ } from "#public"

export const UseInitial = (input: unknown, initial?: () => unknown): unknown => {
  if (!AlmostNullQ(input)) return input
  const d = (initial ?? Void)()
  if (!AlmostNullQ(d)) return d
  return undefined
}
